import { render, staticRenderFns } from "./ForgotPasswordCreatePassword.vue?vue&type=template&id=13d6eb8e&scoped=true&"
import script from "./ForgotPasswordCreatePassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordCreatePassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordCreatePassword.vue?vue&type=style&index=0&id=13d6eb8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6eb8e",
  null
  
)

export default component.exports